import { render, staticRenderFns } from "./soroutingview.vue?vue&type=template&id=ec27c22c&scoped=true&"
import script from "./soroutingview.vue?vue&type=script&lang=js&"
export * from "./soroutingview.vue?vue&type=script&lang=js&"
import style0 from "./soroutingview.vue?vue&type=style&index=0&id=ec27c22c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec27c22c",
  null
  
)

export default component.exports